import React from 'react';
import { TableCell as MuiTableCell, type TableCellProps } from '@mui/material';

export type DataCellProps = TableCellProps;

export default function DataCell({ children, ...props }: DataCellProps) {
  return <MuiTableCell {...props}>{children}</MuiTableCell>;
}
